import Empty from './Empty';
import './Empty.scss';

export default Empty;
